export default {
  submitText: '确认',
  emptyBtn: false,
  column: [
    {
      label: 'id',
      display: false,
      prop: 'id',
    },
    {
      label: '车场名称',
      type: 'tree',
      prop: 'spaceId',
      editDisabled: true,
      disabled: true,
      cell: true,
      props: {
        label: 'title',
        value: 'key',
      },
      dicUrl: '/api/v4ward/car/parkSpaceNode/treeChildrenCarParkNode?id=0',
    },
    {
      label: '车牌号',
      disabled: true,
      prop: 'carNo',
    },
    {
      label: '客户姓名',
      search: true,
      prop: 'customerName',
      disabled: true,
      rules: [
        {
          message: '请输入客户姓名',
          trigger: 'change',
        },
      ],
    },
    {
      label: '客户手机',
      prop: 'customerPhone',
      disabled: true,
      search: true,
      rules: [
        {
          message: '请输入客户手机号',
          trigger: 'change',
        },
      ],
    },
    {
      label: '区域',
      prop: 'regions',
      hide: true,
      type: 'tree',
      disabled: true,
      multiple: true,
      checkStrictly: true,
      dataType: 'string',
      dicData: [],
      props: {
        label: 'title',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择通行区域',
          trigger: 'change',
        },
      ],
    },
    {
      label: '收费标准',
      prop: 'ruleId',
      type: 'tree',
      dicData: [],
      props: {
        label: 'remark',
        value: 'id',
      },
      rules: [
        {
          required: true,
          message: '请选择收费标准',
          trigger: 'blur',
        },
      ],
    },
    {
      label: '操作',
      prop: 'operateType',
      display: false,
    },
    {
      label: '结束时间',
      prop: 'buyEndTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      rules: [
        {
          required: true,
          message: '请输入租赁止期',
          trigger: 'change',
        },
      ],
    },
    {
      label: '结束时间',
      prop: 'endTime',
      type: 'date',
      format: 'yyyy-MM-dd',
      valueFormat: 'yyyy-MM-dd 23:59:59',
      display: false,
    },
    {
      label: '退款金额',
      hide: true,
      prop: 'returnMoney',
      type: 'number',
      mock: {
        type: 'number',
        max: 1,
        min: 2,
        precision: 2,
      },
      minRows: 0.0,
      rules: [
        {
          required: true,
          message: '请输入退费金额',
          trigger: 'blur',
        },
        {pattern: /^([0-9]|[1-9][0-9]{0,7})(\.[1-9]|\.[0-9]{1,2})?$/, message: '只允许填写0-99999999.99'}
      ],
    },
    {
      label: '备注',
      prop: 'remark3',
      hide: true,
      span: 24,
      type: 'textarea',
      minRows: 2,
      maxlength: 100,
      showWordLimit: true,
      overHidden: true,
      rules: [
        {
          required: false,
          message: '请输入退费说明,预计三个工作日内完成退款',
          trigger: 'change',
        },
      ],
    },
  ],
};
